import { createFileRoute } from "@tanstack/react-router";
import { ErrorComponent } from "@/components/Error";
import { Contacts } from "@/contacts/Contacts";

export const Route = createFileRoute("/(authed)/_layout/contacts/")({
  component: Contacts,
  errorComponent: (props) => (
    <ErrorComponent
      title="Contacts List Error"
      message="There was a problem loading the contacts list."
      backTo={{
        path: "/",
        text: "Back to dashboard",
      }}
      {...props}
    />
  ),
});
